<div class="articles__wrapper">
    <div class="articles" id="articles">
        <div class="article" *ngFor="let article of articlesList[articlePage]" (click)="toArticle(article.url)">
            <div class="article__cover">
                <img [src]="article.headerImage.url" alt="" loading="lazy">
            </div>
            <div class="article__title">
                {{article.title}}
            </div>
        </div>
    </div>
    <app-component-controls *ngIf="breakpoints.large || breakpoints.extraLarge" [watchElementId]="'articles'" [navigationStyle]="'plain'" [currentIndex]="articlePage" [cutBy]="6" [elements]="articles" [watchElementId]="'articles'" [animation]="'fade'" (elementsListEvent)="articlesList = $event"
        (navigateToEvent)="articlePage = $event"></app-component-controls>
    <app-component-controls *ngIf="breakpoints.extraSmall" [navigationStyle]="'dots'" [currentIndex]="articlePage" [cutBy]="6" [elements]="articles" [watchElementId]="'articles'" [animation]="'slide'" (elementsListEvent)="articlesList = $event" (navigateToEvent)="onPageChange($event)"></app-component-controls>
</div>
